import React from 'react';

function ImageToBase64Async({base64Image, setBase64Image}) {

    const handleImageUpload = async (event) => {
        const file = event.target.files[0];

        if (file) {
            const reader = new FileReader();

            try {
                const result = await new Promise((resolve, reject) => {
                    reader.onload = (event) => resolve(event.target.result);
                    reader.onerror = (error) => reject(error);
                    reader.readAsDataURL(file);
                });

                setBase64Image(result);
            } catch (error) {
                console.error("Error converting image to Base64:", error);
            }
        }
    };

    return (
        <div>
            <div>
                {base64Image && (
                    <img src={base64Image} alt="Uploaded Image" style={{ maxWidth: '300px' }} />
                )}
            </div>
            <input type="file" accept="image/*" onChange={handleImageUpload} />
        </div>
    );
}

export default ImageToBase64Async;